var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 408,
    viewBox: "0 0 290 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.898438,
    y: 114.418,
    width: 149.967,
    height: 293.455,
    rx: 11.1087,
    fill: "#2e4892"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154.94,
    y: 0.554352,
    width: 134.23,
    height: 407.319,
    rx: 11.1087,
    fill: "#75afac"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgThumb);
export default __webpack_public_path__ + "static/media/bg-thumb.672f6f2e501ffe3e4f6e5195a7f5e5ae.svg";
export { ForwardRef as ReactComponent };